import { ConciergeBell, Home, LayoutDashboard, Route, UserRound } from "lucide-react";

export const NAV_ITEMS = [
  { key: "home", to: "/", label: "Home", icon: Home },
  { key: "trips", to: "/trips", label: "Trips", icon: Route },
  { key: "concierge", to: "/concierge", label: "Concierge", icon: ConciergeBell },
  { key: "profile", to: "/profile", label: "Profile", icon: UserRound },
  { key: "owner", to: "/owner", label: "Owner", icon: LayoutDashboard, ownerOnly: true },
];

export const navFor = (user) => NAV_ITEMS.filter((i) => !i.ownerOnly || user.role === "owner");
